import { createAction, props } from '@ngrx/store';
import { HipUser } from '@webtronic-labs/contracts-hip-hip';

// ------------------- Main ------------------- //

export const setCurrentHipUser = createAction(
  '[Auth] Set current hip user',
  props<{ user: HipUser }>()
);
